import { createSelector } from 'reselect';
import { appState } from './utils';

const _midSelector = createSelector(appState, ({ midSelector }) => midSelector || {});

export const getSelectedMid = createSelector(_midSelector, ({ mid }) => mid);
export const hasSelectedMid = createSelector(_midSelector, ({ hasSelectedMid }) => hasSelectedMid);
